import { ContentModelId } from '../../../../../types/ContentModelId'
import type { ContentPage } from '../../../domain/ContentPage'
import type { ContentPageDTO } from '../../../domain/ContentPageDTO'
import type { PartnerId } from '../../../../../types/PartnerId'
import type { ThemeInsert } from '../../../../theme-insert/domain/ThemeInsert'

import { isAvailablePartner } from '../../../../../utils/filter-by-partner'
import { isNonNullableEntryDTO } from '../../../../../utils/non-nullable-entry-dto'
import { mapEntryDTOList } from '../../../../../utils/map-entry-dto-list'

export const mapContentPageFromApi = (dto: ContentPageDTO, partnerId?: PartnerId): ContentPage | undefined => {
  if (!(isNonNullableEntryDTO(dto) && isAvailablePartner(partnerId, dto.fields.partnerFilter))) {
    return undefined
  }

  const {
    advertorials,
    author,
    content,
    image,
    imageLegend,
    imageUrl,
    isIndexed,
    name,
    partnerId: partnerIdFromDto,
    publishedAt,
    seoDescription,
    seoTitle,
    slug,
    supplierColor,
    supplierName,
    title,
  } = dto.fields

  return {
    advertorials: advertorials && mapEntryDTOList<ThemeInsert>(advertorials),
    author,
    content,
    contentType: ContentModelId.CONTENT_PAGE,
    image: image?.fields,
    imageLegend,
    imageUrl,
    isIndexed,
    name,
    partnerId: partnerIdFromDto,
    publishedAt: new Date(publishedAt),
    seoDescription,
    seoTitle,
    slug,
    supplierColor,
    supplierName,
    title,
  }
}
